import { PropsWithChildren } from 'react';

import { Logo64 } from '../components/Logo';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthState } from '../hooks/useAuthState';
import { Container, Nav, Navbar } from 'react-bootstrap';

export const Layout = ({ children }: PropsWithChildren<{}>) => {
  const { userRoles } = useAuthState();
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <div>
      <Navbar className='navbar navbar-dark' fixed='top'>
        <Container fluid>
          <Navbar.Brand as={Link} to={'/'}>
            <Logo64></Logo64>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls='basic-navbar-nav' />
          <Navbar.Collapse id='basic-navbar-nav'>
            <Nav className=''>
              <Nav.Link as={Link} active={location.pathname === '/'} to={'/'}>
                {t('navbar.homePage')}
              </Nav.Link>
              {userRoles.isSuperAdmin || userRoles.adminIn.length > 0 ? (
                <Nav.Link as={Link} to={'/orgs'} active={location.pathname.startsWith('/orgs')}>
                  {t('navbar.organisation')}
                </Nav.Link>
              ) : null}
              {userRoles.isSuperAdmin || userRoles.adminIn.length > 0 ? (
                <Nav.Link as={Link} to={'/users'} active={location.pathname.startsWith('/users')}>
                  {t('navbar.users')}
                </Nav.Link>
              ) : null}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <main className='main-container text-center'>{children}</main>
    </div>
  );
};
